<template>
  <span class="mr-2">
    {{ clientLocal.login }}
  </span>
</template>

<script>
// import moduleClient from '@/store/client/moduleClient.js'

export default {
  name: 'CellRendererClient',
  computed: {
    clientLocal() {
      // return { login: '...' }
      let obj = this.$store.getters["client/getClienti"](this.params.value);
      return obj ? obj : { login: '...' }
    },
  },
  created() {
    // if (!moduleClient.isRegistered) {
    //   this.$store.registerModule('client', moduleClient)
    //   moduleClient.isRegistered = true
    //   this.$store.dispatch("client/fetchClient")
    // }
  }
}
</script>
